import React, { Component } from "react";
import * as Cookies from "es-cookie";
import { setSecureCookie } from "../../utils/secureCookie";
import { primeNotifications } from "../../utils/notificationsStore";
import { primeStudentGlobals } from "../../utils/studentGlobals";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import AutoStudentLoadingSection from "./AutoStudentLoadingSection";

const LOGIN_USER = gql`
  mutation($username: String!, $token: String) {
    studentLogin(username: $username, token: $token) {
        token
        refreshToken
        user{
            name
            email
            mobile
            valid
            class_id
            exam_id
            exam_name
            student_user_exam_id
            current_plan_id
            mobile_verified
            target_year
            videos
            branch_name
            profile_pic
            userlevel
            forum
            institution_id
            
         }
    }
  }
`;
class AutoStudentLoading extends Component {
  constructor(props) {
    super(props)
    this.state = {
      
      time: "1",
      submitError: ""
    }
  }
  
  componentDidMount = () => {
    if (this.state.time == "1") {
      setTimeout(() => {
        this.handleFormSubmit();
      }, 100);
    }

  }
  handleFormSubmit = e => {
    //e.preventDefault();
    // The token alone identifies the student, so username is sent empty. The
    // :username segment (a phone number) stays in the route only because
    // external systems generate these links; it is not read.
    const token = (this.props.match.params.token || "").split(":")[1] || "";
    this.login("", token).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message)
      });
      console.error("ERR =>", error.graphQLErrors.map(x => x.message));
    });

  };
  login = async (username, token) => {
    await this.props.login({
      variables: {
        username,
        token
      },
      update: (store, { data }) => {

        if (data.studentLogin) {

          console.log("data.studentLogin.user.branch_name", data.studentLogin);
          //localStorage.clear();
          setSecureCookie("studenttoken", data.studentLogin.token);
          setSecureCookie("studentrefreshtoken", data.studentLogin.refreshToken);
          setSecureCookie("studentusername", data.studentLogin.user.name);
          // PII no longer stored client-side; the API returns it masked.

          // PII no longer stored client-side; the API returns it masked.
          setSecureCookie("classid", data.studentLogin.user.class_id);
          setSecureCookie("examid", data.studentLogin.user.exam_id);
          setSecureCookie("student_user_exam_id", data.studentLogin.user.student_user_exam_id);
          primeNotifications();
          primeStudentGlobals();
          setSecureCookie("exam_name", data.studentLogin.user.exam_name);
          setSecureCookie("mobileverified", data.studentLogin.user.mobile_verified);
          setSecureCookie("targetyear", data.studentLogin.user.target_year);
          setSecureCookie("videos", data.studentLogin.user.videos);
          setSecureCookie("branch_name", data.studentLogin.user.branch_name);
          setSecureCookie("profile_pic", data.studentLogin.user.profile_pic);
          setSecureCookie("student_userlevel", data.studentLogin.user.userlevel);
          setSecureCookie("stulogintype", "normal");
          setSecureCookie("forumlink", data.studentLogin.user.forum);
          setSecureCookie("institution_id", data.studentLogin.user.institution_id);
          localStorage.removeItem('profile_pic');
          localStorage.setItem("profile_pic", data.studentLogin.user.profile_pic);

          localStorage.removeItem('packageplan');
          if (this.props.match.params.type.split(":")[1] == "mocktest" || this.props.match.params.type.split(":")[1] == "home") {
            localStorage.setItem("packageplan", this.props.match.params.type.split(":")[1]);
          }
          else {
            localStorage.setItem("packageplan", this.props.match.params.type.split(":")[1].split("-")[1]);
          }

          // Drop the phone number and token from the address bar and history.
          this.props.history.replace(`/student/auto-loading/:-/:-/${this.props.match.params.type}`);

          this.setState({
            time: "2",
            submitError: ""
          })

        }
      }
    });
  };
  render() {

    if (this.state.submitError != "") {
      this.props.history.push("/student/login");
    }

    if (this.state.time == "2") {
      return (
        
          <AutoStudentLoadingSection
            type={this.props.match.params.type.split(":")[1]}
          />
        

      );
    }
    else {
      return null;
    }



  }
}

export default withRouter(
  compose(
    graphql(LOGIN_USER, {
      name: "login"
    })
  )(AutoStudentLoading)
);
